import script from "./modal-trigger.vue?vue&type=script&lang=js"
export * from "./modal-trigger.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__